<script>
import con from '@services/connection'
import { cadastroAtivo } from '@constants/URL'
import Title from '@components/section-title'
import rules from '@constants/Rules'
import Vue from 'vue'
import { getNumber } from '@utils/Format'
import store from '@state/store'
import { GlobalBus } from '@services/bus'
import { MODAL, TIPOS_PU_RESGATE_TOTAL, RELOAD } from '@constants/Text'

export default {
  components: {
    Title,
  },
  data() {
    return {
      rules: rules,
      busModal: new Vue(),
      loading: false,
      ativo: {},
      pu: 0,
    }
  },
  computed: {
    usuarioAtual() {
      return store.getters['user/currentUser'] || {}
    },
    clienteAtual() {
      return store.getters['user/currentClient'] || {}
    },
  },
  created() {
    GlobalBus.$on(MODAL.REMOVE_ASSET, this.open)
  },
  beforeDestroy() {
    GlobalBus.$off(MODAL.REMOVE_ASSET, this.open)
  },
  methods: {
    open(ativo) {
      this.ativo = ativo
      if (TIPOS_PU_RESGATE_TOTAL.includes(this.ativo.Tipo)) {
        this.busModal.$emit('dialog', true)
      } else {
        this.enviar()
      }
    },
    async enviar() {
      if (this.loading) {
        return
      }
      this.loading = true

      let response
      const data = {
        id_conta: this.ativo.id_conta,
        nome_ativo: this.ativo.nome_ativo,
        limpar_extrato: '0',
        id: this.ativo.id,
      }
      if (TIPOS_PU_RESGATE_TOTAL.includes(this.ativo.Tipo)) {
        data['valor_unitario'] = getNumber(this.pu)
      }
      if (this.usuarioAtual.IS_CLIENTE) {
        response = await con.post(cadastroAtivo.ativos.remover, data)
      } else {
        data['id_cliente_app'] = this.clienteAtual.id
        response = await con.delet(
          cadastroAtivo.profissional + this.ativo.id,
          data
        )
      }
      if (response && response.status === 200) {
        this.$showSnack({
          text: 'Exclusão realizada com sucesso',
          button: true,
        })
        GlobalBus.$emit(RELOAD.ASSETS_ONLY, true)
        this.$store.dispatch('consolidator/setClientDataOutdated', true)
        this.busModal.$emit('dialog', false)
      } else {
        this.$showSnack({
          text: 'Exclusão inválida',
          button: true,
        })
      }

      this.loading = false
    },
  },
}
</script>

<template>
  <BaseModal :bus="busModal">
    <Title title="Excluir ativo" />

    <div>
      <p>Informe o Preço Unitário final para confirmar a exclusão:</p>
      <v-currency-field
        v-model="pu"
        prefix="R$ "
        label="Preço Unitário*"
        :rules="[rules.required]"
      />
    </div>

    <template v-slot:actions="{ close }">
      <v-spacer />
      <BaseButton underlined @click="close"> Cancelar </BaseButton>
      <BaseButton primary :loading="loading" @click="enviar">
        Excluir
      </BaseButton>
      <v-spacer />
    </template>
  </BaseModal>
</template>


